import { Component, HostListener, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-sidenav',
  templateUrl: './sidenav.component.html',
  styleUrls: ['./sidenav.component.scss']
})
export class SidenavComponent implements OnInit {
  panelOpenState = true;
  role = "";
  adminmenuOptions = [
    {
      id: false, title: "Administration", subItems: [
        { name: 'Client Master', path: '/administration/client-master' },
        { name: 'Clients', path: '/administration/client' },
        { name: 'Carriers', path: '/administration/carrier', icon: 'home' },
        { name: 'Rate Files', path: '/administration/rate-file' },
        { name: 'Rating Profiles', path: '/administration/rating-profile' },
        { name: 'Create User', path: '/administration/User', icon: 'home' }
      ]
    },
    {
      id: false, title: "Invoicing", subItems: [
        { name: 'Carriers', path: '/invoicing/carrier', icon: 'home' },
        { name: 'Customer Invoices', path: '/invoicing/customer-invoice' }
      ]
    },
  ]
  usermenuOptions = [
    {title: "Invoicing" ,subItems: [{name: 'Carriers', path: '/invoicing/carrier',icon:'home'}, {name: 'Customer Invoices', path: '/invoicing/customer-invoice'}]},
  ]

  constructor( private router : Router){

  }
  @HostListener('document:click', ['$event'])
public handleClick(event: Event): void {
 if (event.target instanceof HTMLAnchorElement) {
   const element = event.target as HTMLAnchorElement;
   if (element.className === 'routerlink') {
     event.preventDefault();
     const route = element?.getAttribute('href');
     if (route) {
       this.router.navigate([`/${route}`]);
     }
   }
 }
}
  identifyer(index,item){
    return item.name;
  }

  ngOnInit(): void {
    this.role = localStorage.getItem('Role');
  }

  setPanelOpenState(flag){
    if(flag){
      this.panelOpenState = true
    }
    else{
      this.panelOpenState = false
    }
      }
}
